import { IFormService } from "../../service/form/FormService";

export default class SetFormalCheckStatusInteractor {
  private formService: IFormService;

  constructor(formService) {
    this.formService = formService;
  }

  async execute(formId: number, status: string) {
    return this.formService.setFormalCheckStatus(formId, status);
  }
}
